@for (option of menu; track option) {
  @if (!isEmpty(option)) {
    <button
      class="option"
      (click)="onItemClick(option)"
      (mouseenter)="showChildren($event, option)"
      [disabled]="option.disabled"
      (mouseleave)="subContextMenuOpen = false"
      >
      @if (option.icon) {
        <i class="material-icons">{{option.icon}}</i>
      }
      <span class="title" [attr.title]="option.title"> {{option.title}} </span>
      @if (option.children?.length) {
        <span class="right">
          <i class="material-icons">play_arrow</i>
        </span>
      }
      <!-- We can use recursion to load up any children -->
      <!-- Sub children start -->
      @if (subContextMenuOpen) {
        <eva-context-menu
          [event]="getSubMenuPosition()"
          [menu]="subMenuItems"
          [parentDepth]="elementDepth"
          >
        </eva-context-menu>
      }
      <!-- Sub children end -->
    </button>
  }
  @if (isEmpty(option)) {
    <div class="divider" [style.background-color]="option.color"></div>
  }
}
